var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "internal-page-main-section contact-page-main col-12" },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "contact-section-main col-12 float-l" }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "p",
                  {
                    staticClass:
                      "color-333333 heading-text-20 line-height-24 width-full font-text-semi-medium-mont center"
                  },
                  [_vm._v(" Reach Out to us ")]
                ),
                _vm._v(" "),
                _c(
                  "h2",
                  {
                    staticClass:
                      "color-red heading-text-32 line-height-36 font-text-semi-medium-mont center pb-25 border-bottom-dddddd contact-title"
                  },
                  [_vm._v(" We’d love to hear from you ")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "color-333333 heading-text-20 line-height-24 width-full font-text-semi-medium-mont center mt-20"
                  },
                  [_vm._v(" Get in touch and let us know how we can help")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "color-333333 heading-text-20 line-height-24 width-full font-text-semi-medium-mont center mt-20"
                  },
                  [
                    _vm._v(" If you have  a question regarding pay, "),
                    _c("br"),
                    _vm._v(
                      "employment verification or tax forms, please contact "
                    ),
                    _c("a", { attrs: { href: "mailto:" + _vm.payroll } }, [
                      _vm._v(" Payroll ")
                    ])
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "bottom-contact-detail-main col-12 float-l" },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "view-btn-small contact-email-btn col-12"
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "a",
                            {
                              staticClass: "hvr-sweep-to-right-blue",
                              attrs: { href: "mailto:" + _vm.hr_email }
                            },
                            [_vm._v(" Email Us ")]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "contact-detail col-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "contact-middle" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "contact-top-section float-l width-full"
                            },
                            [
                              _vm._m(1),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "left-text-section col-12 col-sm-5 col-md-5 col-lg-5 float-l"
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont float-l width-full"
                                      },
                                      [
                                        _vm._v(
                                          " Can’t reach your onsite HR Admin? "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont float-l width-full mt-20"
                                      },
                                      [_vm._v(" Contact Us at ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "color-blue heading-text-28 line-height-32 font-text-bold-mont float-l width-full mt-2"
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "tel:" + _vm.hr_admin_number,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mobilenumber(
                                                  _vm.mobilenumber(
                                                    _vm.mobilenumber(
                                                      _vm.hr_admin_number,
                                                      0,
                                                      "("
                                                    ),
                                                    4,
                                                    ") "
                                                  ),
                                                  9,
                                                  "-"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "left-text-section col-12 col-sm-5 col-md-5 col-lg-5 float-l"
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont float-l width-full"
                                      },
                                      [
                                        _vm._v(
                                          " To report a concern use our Employee Hotline at "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "color-blue heading-text-28 line-height-32 font-text-bold-mont float-l width-full mt-20"
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "tel:" + _vm.employee_hotline,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mobilenumber(
                                                  _vm.mobilenumber(
                                                    _vm.mobilenumber(
                                                      _vm.employee_hotline,
                                                      0,
                                                      "("
                                                    ),
                                                    4,
                                                    ") "
                                                  ),
                                                  9,
                                                  "-"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "contact-bottom-section float-l width-full mt-80"
                            },
                            [
                              _vm._m(2),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "left-text-section col-12 col-sm-5 col-md-5 col-lg-5 float-l"
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "color-333333 heading-text-18 line-height-22 font-text-semi-medium-mont float-l width-full",
                                        attrs: {
                                          href: "mailto:" + _vm.hr_email
                                        }
                                      },
                                      [_vm._v(" " + _vm._s(_vm.hr_email) + " ")]
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "right-social-media col-12 col-sm-5 col-md-5 col-lg-5 float-l"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "row" },
                                    [
                                      _vm._l(_vm.socialMediaLinks, function(
                                        social,
                                        index
                                      ) {
                                        return [
                                          social.social_title.value ==
                                          "facebook"
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "btn-5",
                                                    attrs: {
                                                      href: social.social_value,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [_vm._m(3, true)]
                                                )
                                              ]
                                            : social.social_title.value ==
                                              "instagram"
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "btn-5",
                                                    attrs: {
                                                      href: social.social_value,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [_vm._m(4, true)]
                                                )
                                              ]
                                            : social.social_title.value ==
                                              "linkedin"
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "btn-5",
                                                    attrs: {
                                                      href: social.social_value,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [_vm._m(5, true)]
                                                )
                                              ]
                                            : _vm._e()
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "internal-page-banner-main col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "page-title" }, [
            _c("h1", [_vm._v(" Contact HR ")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "left-call-icon col-12 col-sm-1 col-md-2 col-lg-2 float-l"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("i", { staticClass: "hi-icon hr-call" })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "left-call-icon col-12 col-sm-1 col-md-2 col-lg-2 float-l"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("i", { staticClass: "hi-icon hr-email" })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-facebook-f" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-instagram" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-linkedin" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf6573c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf6573c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = null
// module chunks = 